import * as mutationTypes from '@/store/mutation-types'
import { personalAssets } from '@/api/transaction'
import { sendWSPush } from '@/utils/webSocket'
import KLineEntity from '@/utils/klineEntity'
import KLineDataHelper from '@/utils/klineDataHelper'

const transaction = {
  namespaced: true,
  state: {
    interval: '15m', // 获取历史数据时需调用utils下的getResolution方法转换
    tradingPairData: {
      marketId: 1,
      market: 'btc_usdt'
    }, // 当前交易对数据
    dollarExhibition: true, // 展示的价格（默认：美元）
    controlCoin: 0, // 排序：名称
    controlPrice: 0, // 排序：价格
    controlUpDown: 0, // 排序：涨幅
    // 盘口买入和卖出第一个价格和改变后的价格
    handicapFirstPrice: {
      unassigned: true,
      buyFirstPrice: '',
      sellFirstPrice: ''
    },
    shimHandicap: 'buySell', // 当前选择的盘口（默认：买卖盘）
    buySellTop: -420, // 盘口距离顶部的距离（默认：-420）
    currentCoinBalance: ['', ''], // 当前币种余额
    // readyCenter: {
    //   twoCoinBalanceReadyStatus: false, // USDT 和 当前币种余额 准备状态（http 请求）
    //   currentCoinBalanceReadyStatus: false, // 当前币种余额准备状态（http 请求）
    //   currentCoinPriceReadyStatus: false // 当前币种价格准备状态（websocket 请求）
    // },
    klineData: [], // K线
    plateData: {}, // 盘口
    realData: [], // 实时成交
    indicator: ['MA', 'VOL'],
    currentSkin: 'black', // 皮肤（所有的皮肤类型为：black、white）（默认：black暗色）

    quotes: {}, // 实时行情
    marketTabs: [] // 交易中心市场tab
  },
  mutations: {
    [mutationTypes.CLEAR_KLINE_DATA](state) {
      state.klineData = []
    },
    [mutationTypes.ADD_KLINE_DATA](state, { market, list, kline }) {
      const tempArr = list ? [] : [...state.klineData]
      if (market === state.tradingPairData.market) {
        if (list) {
          tempArr.push(...list.map((item) => new KLineEntity(item)))
        } else {
          tempArr.pop()
          tempArr.push(new KLineEntity(kline))
        }

        KLineDataHelper.calculate(tempArr)
        state.klineData = tempArr
      }
    },
    [mutationTypes.ADD_PLATE_DATA](state, value) {
      state.plateData = value
    },
    [mutationTypes.ADD_REAL_DATA](state, { data, market }) {
      if (market === state.tradingPairData.market) {
        state.realData = data
      }
    },
    [mutationTypes.SET_INDICATOR](state, value) {
      state.indicator = value
    },
    [mutationTypes.SET_TRADING_PAIR](state, tradingPair) {
      state.tradingPair = tradingPair
    },
    [mutationTypes.SET_TRADING_PAIR_DATA](state, tradingPairData) {
      state.tradingPairData = tradingPairData
    },
    [mutationTypes.SET_DOLLAREXHIBITION](state, payload) {
      state.dollarExhibition = payload
    },
    [mutationTypes.SET_HANDICAP_FIRST_PRICE](state, priceObj) {
      state.handicapFirstPrice = priceObj
    },
    [mutationTypes.SET_CURRENT_HANDICAP](state, handicap) {
      state.shimHandicap = handicap
    },
    [mutationTypes.SET_BUYSELL_TOP](state, top) {
      state.buySellTop = top
    },
    [mutationTypes.SET_CONTROL_COIN](state, coin) {
      state.controlCoin = coin
    },
    [mutationTypes.SET_CONTROL_PRICE](state, price) {
      state.controlPrice = price
    },
    [mutationTypes.SET_CONTROL_UPDOWN](state, updown) {
      state.controlUpDown = updown
    },
    [mutationTypes.SET_TRADING_PAIR_COINS_BALANCE](state, balance) {
      state.currentCoinBalance = balance
    },
    [mutationTypes.SET_INTERVAL](state, interval) {
      state.interval = interval
    },
    [mutationTypes.SET_CURRENT_SKIN](state, type) {
      state.currentSkin = type
    },
    [mutationTypes.SET_QUOTE_DATA](state, quote) {
      state.quotes = { ...state.quotes, ...{ [quote.marketId]: quote } }
      if (quote.marketId === state.tradingPairData.marketId) {
        state.tradingPairData = quote
      }
      const area = quote.area.toUpperCase()
      if (!state.marketTabs.includes(area)) {
        state.marketTabs.push(area)
      }
    }
  },
  actions: {
    // 获取用户当前币对各代币余额
    async getTwoCoinBalance({
      commit,
      rootState,
      rootGetters: { lowerCaseBaseCurrency, lowerCaseQuoteCurrency }
    }) {
      commit(mutationTypes.SET_TRADING_PAIR_COINS_BALANCE, ['', ''])
      // eslint-disable-next-line
      const plateParams = {
        channel: `${lowerCaseBaseCurrency}_${lowerCaseQuoteCurrency}`,
        language: 'zh'
      }
      if (rootState.token) {
        // 采用继发关系写法避免用户登录信息过期时，出现多次“登录信息过期”提示
        const [
          { amountUsable },
          { amountUsable: amountUsable1 }
        ] = await Promise.all([
          personalAssets({ coinName: lowerCaseBaseCurrency }),
          personalAssets({ coinName: lowerCaseQuoteCurrency })
        ]).finally(() => {
          sendWSPush(plateParams) // 注意：在获取币种数据失败时，也需要发送盘口数据
        })
        commit(mutationTypes.SET_TRADING_PAIR_COINS_BALANCE, [
          Number(amountUsable),
          Number(amountUsable1)
        ])
      } else {
        sendWSPush(plateParams)
      }
    }
  }
}

export default transaction
